import React from "react";
import PropTypes from "prop-types";

const BrandReturnPolicy = ({ currentBrand }) => {
  const { display, url, iconUrl } = currentBrand;
  return (
    <div className="product-details__return_policy-container">
      <div className="product-details__return_policy-icon">
        <img
          src={iconUrl}
          alt="return policy icon"
        />
      </div>
      <div className="product-details__return_policy-wrapper">
        <span>
          Sold and Shipped by {display}. See{' '}
          <a
            className="product-details__return_policy-link"
            href={url}
            rel="noreferrer"
            target="_blank"
          >
            FAQ's
          </a>
          {' '}for details.
        </span>
      </div>
    </div>
  );
};

BrandReturnPolicy.propTypes = {
  currentBrand: PropTypes.shape({
    display: PropTypes.string,
    url: PropTypes.string,
    iconUrl: PropTypes.string,
  }).isRequired,
};

export default BrandReturnPolicy;